/**
 * @Author: lihaifa
 * @description 拷贝的类方法
 */
class CopyClass {
  constructor() {
    this.idName = `copy-textarea-${Math.floor(Math.random() * 10000)}`;
  }

  queryCopyCommandSupported() {
    return new Promise((resolve, reject) => {
      const errorObj = new Error('浏览器不支持复制功能！');
      try {
        const result = document.queryCommandSupported('copy');
        if (result) {
          resolve();
        } else {
          reject(errorObj);
        }
      } catch (error) {
        reject(errorObj);
      }
    });
  }

  setRange() {
    return new Promise((resolve, reject) => {
      try {
        //  创建range对象
        const range = document.createRange();
        const dom = document.getElementById(this.idName);
        // range.selectNodeContents(textarea);
        // // 获取复制内容的 id 选择器
        range.selectNode(dom);
        // // 创建 selection对象
        const selection = window.getSelection();
        // // 如果页面已经有选取了的话，会自动删除这个选区，没有选区的话，会把这个选取加入选区
        if (selection.rangeCount > 0) {
          selection.removeAllRanges();
        } else {
          //
        }
        // textarea.setSelectionRange(0, 99999); /* 为移动设备设置 */
        // 将range对象添加到selection选区当中，会高亮文本块
        selection.addRange(range);
        this.execCommand().then(() => {
          resolve();
        }).catch(e => {
          reject(e);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  insertDom(val, type) {
    return new Promise((resolve, reject) => {
      try {
        const dom = document.createElement(type || 'div'); // 创建input对象
        dom.id = this.idName;
        //  避免Safari的选中效果
        dom.style.width = 0;
        dom.style.position = 'fixed';
        dom.style.left = '-999px';
        dom.style.top = '10px';
        if (type === 'textarea') {
          dom.value = val;
          dom.setAttribute('readonly', 'readonly');
        } else {
          dom.innerHTML = val;
        }
        document.body.appendChild(dom);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  removeInput() {
    return new Promise((resolve, reject) => {
      try {
        document.getElementById(this.idName).remove();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  execCommand() {
    return new Promise((resolve, reject) => {
      try {
        //  该方法已弃用
        const result = document.execCommand('copy');
        if (result) {
          resolve();
        } else {
          reject(new Error('document.execCommand方法未生效'));
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  inputSelectCopy() {
    return new Promise((resolve, reject) => {
      try {
        document.getElementById(this.idName).select();
        this.execCommand().then(() => {
          resolve();
        }).catch(e => {
          reject(e);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  clipboardWriteText(val) {
    return new Promise((resolve, reject) => {
      try {
        navigator.clipboard.writeText(val).then(res => {
          resolve();
        }).catch(e => {
          reject(e);
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  copy(val) {
    return new Promise((resolve, reject) => {
      if (val && typeof val === 'string') {
        const errorObj = new Error('页面复制内容失败！');
        this.clipboardWriteText(val).then(() => {
          resolve();
        }).catch(e => {
          this.queryCopyCommandSupported().then(() => {
            this.insertDom(val).then(res => {
              this.setRange().then(() => {
                console.log("setRange");
                resolve();
                this.removeInput().then(() => { }).catch(e => { });
              }).catch(e => {
                this.removeInput().then(() => {
                  this.insertDom(val, 'textarea').then(() => {
                    this.inputSelectCopy().then(() => {
                      console.log("inputSelectCopy");
                      resolve();
                      this.removeInput().then(() => { }).catch(e => { });
                    }).catch(e => {
                      reject(errorObj);
                      this.removeInput().then(() => { }).catch(e => { });
                    });
                  }).catch(e => {
                    reject(errorObj);
                    this.removeInput().then(() => { }).catch(e => { });
                  });
                }).catch(e => {
                  reject(errorObj);
                });
              });
            }).catch(e => {
              reject(errorObj);
            });
          }).catch(e => {
            reject(e);
          });
        });
      } else {
        reject(new Error('不能复制无效内容！'));
      }
    });
  }
}

/**
 * @description 拷贝
 */
export default function Copy(val) {
  const copyClass = new CopyClass();
  return copyClass.copy(val);
}

